import { useQuery } from '@tanstack/react-query';

import { ValidationType } from 'src/features/validationTypes/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/validations/validation-type/:validationTypeId/';

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    validationTypeId: string;
}

const queryFn = ({ parkingId, validationTypeId }: DTO): Promise<ValidationType> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, validationTypeId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as GET_VALIDATION_TYPE_RESOURCE, useQueryHook as useGetValidationType };
